import type { IconProps } from './types';

export const ArrowLeftIcon = (props: IconProps) => {
  const { color = 'currentColor', size = 24, ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path d="M21.8438 12H0.75" stroke={color} strokeWidth="1.5" />
      <path d="M8.25 19.5L0.75 12L8.25 4.5" stroke={color} strokeWidth="1.5" />
    </svg>
  );
};
